import {UploadStatusItemStatus} from '@netx/core-upload-next/constants';

export enum UploadAssetPref {
	SELECTED_ATTRIUBUTE_SET = 'attribute.attributeSets.selected.uploadAsset',
	ATTRIBUTE_PANE_WIDTH = 'upload.asset.attributePaneWidth',
}

export const UploadStatusAssetItemStatus = {
	...UploadStatusItemStatus,
	COLLISION_REJECTION: 'collision_rejection',
	DUPLICATE: 'duplicate',
	IMPORTING: 'importing',
} as const;
export type UploadStatusAssetItemStatus =
	typeof UploadStatusAssetItemStatus[keyof typeof UploadStatusAssetItemStatus];

export const ACTIONABLE_COMPLETED_STATUSES = [
	UploadStatusAssetItemStatus.DUPLICATE,
	UploadStatusAssetItemStatus.COLLISION_REJECTION,
] as string[];
